function createNumberMap(size) {
  const map = new Map();
  for (let i = 0; i < size; i++) {
    map.set(i, 0);
  }
  return map;
}

function getRowSize<T extends { isPremium: boolean }>(row: T[]) {
  return row.reduce((size, item) => size + (item.isPremium ? 2 : 1), 0);
}

// it should be 10-20 items.
// pagesize - 2, or 3, or 4
// items should be only regular, or regular and premium combined
export function arrangeItemsExtended<T extends { isPremium: boolean }>(
  items: T[],
  pageSize: number = 2,
  hideNotComplete = true,
): T[][] {
  let arrangedBigArr: T[][] = Array.from({ length: items.length }, () => []);
  let lastUnfinishedIndex = 0;
  const sizesMap = createNumberMap(items.length);
  for (const item of items) {
    const itemSize = item.isPremium ? 2 : 1;

    if (sizesMap.get(lastUnfinishedIndex) + itemSize > pageSize) {
      for (let i = lastUnfinishedIndex + 1; i < items.length; i++) {
        if (sizesMap.get(i) + itemSize > pageSize) {
          continue;
        } else {
          arrangedBigArr[i].push(item);
          sizesMap.set(i, sizesMap.get(i) + itemSize);
          break;
        }
      }
      continue;
    }

    arrangedBigArr[lastUnfinishedIndex].push(item);
    sizesMap.set(lastUnfinishedIndex, sizesMap.get(lastUnfinishedIndex) + itemSize);
    if (sizesMap.get(lastUnfinishedIndex) === pageSize) {
      for (let i = lastUnfinishedIndex + 1; i < items.length; i++) {
        if (sizesMap.get(i) === pageSize) {
          continue;
        } else {
          lastUnfinishedIndex = i;
          break;
        }
      }
    }
  }
  arrangedBigArr = arrangedBigArr.filter((val) => !!val.length);

  if (!hideNotComplete) {
    return arrangedBigArr;
  }

  return arrangedBigArr.filter((row) => getRowSize(row) === pageSize);
}
